
import { create } from "zustand";
import { devtools } from "zustand/middleware";




const storeApi = (set) => ({

    activeDescuento: null,
    descuentos: [],
    isLoadingDescuento: false,
    totalDescuento: 0,
    datosDescuento: null,

    
});






export const useDescuentosStore = create()(
    devtools(
        storeApi
    )
)
